import React, { useEffect, useState } from "react";
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography, Box, Checkbox } from "@mui/material";
import CustomCheckbox from "./CustomCheckbox"; 
import data from "./data"; // You can move your data to a separate file  
import DailyTotalsRow from "./DailyTotalsRow";
import NoData from "../NoData/NoData";
import DailyTotalsSkeleton from "./DailyTotalsSkeleton";

const cellStyle = {
    padding: '10px 16px',
};

const DailyTotalsTable = ({ isMeView = false, isAllView = false }) => {
    const [selectedRows, setSelectedRows] = useState([]);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);  // Ensure this gets called
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const handleSelectAll = () => {
        if (selectedRows.length === data.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(data.map((row) => row.id));
        }
    };

    const handleRowToggle = (id) => () => {
        setSelectedRows((prev) =>
            prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
        );
    };

    const allSelected = selectedRows.length === data.length;
    const someSelected = selectedRows.length > 0 && !allSelected;

    return (
        <> 
            <TableContainer component={Paper} sx={{ boxShadow: 'none', background: 'transparent', marginBottom: '24px' }}>
                <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 5px' }}>
                    <TableHead sx={{ backgroundColor: '#DFDFDF' }}>
                        <TableRow>
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                minWidth: '50px',
                                maxWidth: '32px',
                                borderTopLeftRadius: '10px',
                                borderBottomLeftRadius: '10px'
                            }}>
                                <CustomCheckbox
                                    checked={allSelected}
                                    indeterminate={someSelected}
                                    onChange={handleSelectAll}
                                />
                            </TableCell>
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center', }}>#</TableCell>
                             {!isMeView && (<TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Members</TableCell> )}
                            {!isAllView && (<TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'left' }}>Project</TableCell>)} 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Mon, Mar 3, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Tue, Mar 4, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Wed, Mar 5, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Thu, Mar 6, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Fri, Mar 7, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Sat, Mar 8, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Sun, Mar 9, 2025</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Total hours</TableCell> 
                            <TableCell sx={{ ...cellStyle, border: 'none', color: '#626262', textAlign: 'center',whiteSpace:'nowrap' }}>Avg Activity</TableCell>  
                            <TableCell sx={{
                                ...cellStyle,
                                border: 'none',
                                borderTopRightRadius: '10px',
                                borderBottomRightRadius: '10px',
                                textAlign: 'center',
                                whiteSpace:'nowrap'
                            }}>
                                Total Amount
                            </TableCell>
                        </TableRow>
                    </TableHead> 
                    <TableBody>
                        {loading ? (
                            [...Array(3)].map((_, i) => <DailyTotalsSkeleton key={i} />)
                        ) : data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center" sx={{ padding: '40px 16px' }}>
                                    <NoData />
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row) => (
                                <DailyTotalsRow
                                    key={row.id}
                                    row={row}
                                    isSelected={selectedRows.includes(row.id)}
                                    onSelectToggle={handleRowToggle(row.id)}
                                    isMeView={isMeView}
                                    isAllView={isAllView}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default DailyTotalsTable;